import React, { useEffect } from "react";
import Agents from "./Agents";
import { useDispatch, useSelector } from "react-redux";
import { getAgents, filterAgents } from "../../redux/actions/agents";
import { ExclamationIcon } from "@heroicons/react/solid";

export default function AgentList() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAgents());
  }, [dispatch]);

  const { filterdAgents, agents } = useSelector((state) => state.agents);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-4 px-8 align-middle">
            <div className="shadow-sm ring-1 ring-black ring-opacity-5">
              <div>
                <div className="flex justify-end px-4 sm:px-6 lg:px-8">
                  <select
                    onChange={(e) =>
                      dispatch(
                        filterAgents({
                          agents,
                          loanStatusFilter: e.target.value,
                        })
                      )
                    }
                    name="loanStatus"
                    className="pr-10 py-2 mr-2 mt-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
                  >
                    <option value="">All</option>
                    <option value="green">Green</option>
                    <option value="yellow">Yellow</option>
                    <option value="red">Red</option>
                  </select>
                </div>
                {filterdAgents.length !== 0 ? (
                  <Agents filterdAgents={filterdAgents} />
                ) : (
                  <div className="bg-red-50 border-l-4 border-red-400 p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <ExclamationIcon
                          className="h-5 w-5 text-red-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3">
                        <p className="text-sm text-red-700">
                          No entries are found with that loan status.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
